/**
 * The people on the About page. The bundled five are the offline sample; once
 * the CMS has answered the list is replaced with the real team, in two groups
 * the page shows as tabs.
 */

export type TeamGroup = 'The Board' | 'Team Members';

export const TEAM_GROUPS: TeamGroup[] = ['The Board', 'Team Members'];

export interface TeamMember {
    first: string;
    last: string;
    name: string;
    role: string;
    /** Portrait URL; empty until one is uploaded — the card then shows initials. */
    photo: string;
    /** Bio paragraphs; empty until someone writes them. */
    bio: string[];
    group: TeamGroup;
}

/** "Nelson Olanipekun" → "Nelson" + "Olanipekun"; a single word is all last name. */
export function nameParts(name: string): { first: string; last: string } {
    const words = name.trim().split(/\s+/).filter(Boolean);
    if (words.length <= 1) return { first: '', last: words[0] ?? '' };
    return { first: words[0], last: words.slice(1).join(' ') };
}

export const initialsOf = (name: string): string =>
    name
        .split(/\s+/)
        .filter(Boolean)
        .slice(0, 2)
        .map((w) => w[0]?.toUpperCase() ?? '')
        .join('');

/** The people on the About page, as the CMS lists them. */
export const TEAM: TeamMember[] = [];

/** Members of one group, in page order. */
export const teamIn = (group: TeamGroup): TeamMember[] => TEAM.filter((m) => m.group === group);
